import './../common.js'

import { leverok_store } from './vuejs/store/leverok_store'
import { game_store } from './vuejs/store/game_store'

import { extend } from "vee-validate";

import { is_not, length } from "vee-validate/dist/rules";
extend("is_not", is_not);
extend("length", length);

extend("isAlreadyRegistered", async (value, [target]) => {
  try {
    const response = await axios.get(`${game_store.getters.getGameUrlPrefix}/is_registered?values[]=${value}${target !== '' ? `&values[]=${target}` : ''}`)
    return response.data.valid ? response.data.valid : response.data.message;
  } catch (error) {
    return "Une erreur s'est produite"
  }
});

window.Toastr.options = {
  "timeOut": "15000"
}

import VueRouter from 'vue-router';
import PortalVue from 'portal-vue';

Vue.filter("formatTo_DDMMYYYY", date => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  date = new Date(date);
  return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join('/');
});

Vue.filter("formatTo_DDMMYYYYHHMM", date => {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  date = new Date(date);
  return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join('/') + " à " + [pad(date.getHours()), pad(date.getMinutes())].join(':');
});

Vue.filter("formatTo_Day_Month_Year", date => {
  date = new Date(date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

  if (date.indexOf("1 ", 0) !== -1) {
    date = date.replace(/1/, '1er');
  }
  return date;
});

Vue.filter("formatTo_Day_Month", date => {
  date = new Date(date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });

  if (date.indexOf("1 ", 0) !== -1) {
    date = date.replace(/1/, '1er');
  }
  return date;
});

// INIT
document.addEventListener("DOMContentLoaded", function () {

  if (document.getElementById('load')) {
    $('#load').fadeOut(500);
  }

  if (document.getElementById("parrainage-form-area")) {
    new Vue({
      el: "#parrainage-form-area",
      components: {
        "parrainage": () => import("./vuejs/components/Parrainage"),
      },
    });
  }

  if (document.getElementById("carte-demat-form-area")) {
    new Vue({
      el: "#carte-demat-form-area",
      components: {
        "carte-demat": () => import("./vuejs/components/CarteDemat"),
      },
    });
  }

  if (document.getElementById("activate-carte-demat-form-area")) {
    new Vue({
      el: "#activate-carte-demat-form-area",
      components: {
        "activate-carte-demat": () => import("./vuejs/components/ActivateCarteDemat"),
      },
    });
  }

    if (document.getElementById("game")) {
        Vue.use(PortalVue);

        new Vue({
            el: "#game",
            store: game_store,
            components: {
                "layout": () => import("./vuejs/components/games/Layout"),
            },
            /*created() {
                this.fetchHighlightedGifts().then(
                    res => this.UPDATE_HIGHLIGHTED_GIFTS(res),
                    () => Toastr["error"]("Une erreur s'est produite lors de la récupération des gains de la semaine"),
                );
            },
            methods: {
                ...mapActions([
                    'fetchHighlightedGifts'
                ]),
                ...mapMutations([
                    'UPDATE_HIGHLIGHTED_GIFTS'
                ]),
            },
            computed: {
                ...mapGetters(['getMainFormPath', 'getClientInfo']),
            },*/
        });
    }

  if (document.getElementById("game-leverok")) {
    Vue.use(PortalVue);

    const routes = [
      { path: `https://www.autodistribution.fr/themes/leverok`, name: 'Boutique Leverok', use_router: false, external: true },
      { path: `https://autodistribution.dansmonmagasin.com/html/catalogue_leverok_2025_792/`, name: 'Les produits Leverok', use_router: false, external: true },
      { path: `${leverok_store.getters.getGameUrlPrefix}/:source/:code?/a-propos`, component: () => import("./vuejs/components/jeu_leverok/Help"), name: 'à propos de Leverok', use_router: true },
      { path: `https://www.autodistribution.fr/magasins-pieces-auto`, name: 'Trouver un magasin autodistribution', use_router: false, external: true },

      // { path: `${store.getters.getGameUrlPrefix}/:source/:code?/regles`, component: () => import("./vuejs/components/jeu_leverok/Rules"), name: 'Les règles du jeu', use_router: true },
      // { path: `${store.getters.getGameUrlPrefix}/:source/:code?/gains`, component: () => import("./vuejs/components/jeu_leverok/Gains"), name: 'Les gains', use_router: true },
      // { path: `/reglement-jeu-ete-sportif.pdf`, name: 'Règlement', use_router: false, external: true },
      // { path: `${store.getters.getGameUrlPrefix}/:qrcode/reglement`, component: () => import("./vuejs/components/jeu_leverok/Reglement"), name: 'Règlement du jeu' },
      // { path: '/${store.getters.getGameUrlPrefix}/aide', component: () => import("./vuejs/components/jeu_leverok/Help"), name: 'Besoin d\'aide ?' },
      { path: `${leverok_store.getters.getGameUrlPrefix}/:source?/:code?`, component: () => import("./vuejs/components/jeu_leverok/Layout.vue"), name: 'Je m\'inscris', props: true, use_router: true },

      { path: `${leverok_store.getters.getGameUrlPrefix}/:source?/:code?/*`, name: 'default' },
    ]

    const router = new VueRouter({
      routes,
      mode: 'history',
      scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
      }
    })

    router.beforeEach((to, from, next) => {
      if (to.name !== 'Je m\'inscris' && from.name === null) {
        next({ name: 'Je m\'inscris', params: { source: to.params.source, code: to.params.code } })
      }

      next() // make sure to always call next()!
    })

    new Vue({
      el: "#game-leverok",
      router,
      store: leverok_store,
      components: {
        "menu-game": () => import("./vuejs/components/jeu_leverok/MenuGame"),
      },
    });
  }
})
